module.exports = __webpack_public_path__ + "03_short_gold.eeb50761.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_short_gold.png
// module id = MKMv
// module chunks = 0